import { useSearchParams } from "react-router";
import { AuthForm } from "@/components/auth/auth-form";
import { usePageTitle } from "@shared/client/view";
import { useT } from "@shared/client/locale";

export default function LoginPage() {
  usePageTitle(useT().auth.pageTitles.login);
  const [params] = useSearchParams();
  return <AuthForm mode="login" initialError={params.get("error") || ""} />;
}
